import { Component, Fragment } from 'react';
import {
    Box,
    Collapse,
    ImageListItem,
    Grid,
    Paper
} from '@mui/material';

const Constants = require("../constants/Constants");
let MAPS = Constants.MAPS
let IMAGE_URL = Constants.IMAGE_URL


class MapSelect extends Component {
    constructor(props) {
        super(props);
        this.state = { value: "" }
        this.id = props.id
    }



    render() {
        return (
            <Fragment>
                <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                >
                    <img
                        src={`${this.props.raceData.url}`}
                        sx={{ mt: 3, mb: 2 }}
                        onClick={this.props.toggleCourses}
                        style={{ width: "75%", maxWidth: "400px", borderRadius: 12 }}
                        alt={this.props.raceData.name}
                        value={this.props.raceData.id}
                    />
                </Box>
                <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                >
                    <Collapse in={this.props.showCourses}>
                        <Grid container rowSpacing={1} sx={{ p: 1 }} >
                            {MAPS?.map((cup) =>
                                <Grid item sx={{ p: 1, width: { xs: 1 / 2, md: 1 / 4 } }} key={`grid-cup-${cup.id}`}>
                                    <Box
                                        display="flex"
                                        justifyContent="center"
                                        alignItems="center"
                                        sx={{ p: 1 }}
                                    >
                                        <Paper sx={{ backgroundColor: "#000000", borderRadius: 3 }}>
                                            <img
                                                key={`cup-${cup.id}`}
                                                src={`${IMAGE_URL}${cup.url}`}
                                                height="70px"
                                                alt={cup.name}
                                                loading="lazy"
                                                value={cup.id}
                                                name={cup.name}

                                            />
                                        </Paper>
                                    </Box>
                                    {
                                        cup.races?.map((race) =>
                                            <ImageListItem key={`race-${race.id}`} className={race.name}>
                                                <Box
                                                    display="flex"
                                                    justifyContent="center"
                                                    alignItems="center"
                                                    sx={{ mb: .5 }}
                                                >
                                                    <img
                                                        src={`${IMAGE_URL}${race.url}`}
                                                        alt={race.name}
                                                        loading="lazy"
                                                        value={race.id}
                                                        name={race.name}
                                                        mapImage={race.mapImage}
                                                        style={{ minWidth: "150px", width: "100%", maxWidth: "200px", borderRadius: 12 }}
                                                        onClick={(event) => this.props.handleRace(event)}
                                                    />
                                                </Box>
                                            </ImageListItem>
                                        )
                                    }
                                </Grid>
                            )}
                        </Grid>
                    </Collapse>
                </Box>
            </Fragment>
        )

    }
}

export default MapSelect
